import { useEffect, useState } from "react";
import { TextField, InputAdornment } from "@mui/material";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";
import { MAX_CHAR_LIMIT } from "../../../../../utils/Constant";

export default function TableCellField({
  header,
  cell,
  updatedValue,
  disabled = false,
  isQC = false,
}: any) {
  const [value, setValue] = useState<string | null>(null);

  useEffect(() => {
    if (cell) {
      isQC
        ? cell?.answers?.qc?.answer
          ? setValue(cell?.answers?.qc?.answer)
          : setValue(cell?.answers?.inspector?.answer || null)
        : setValue(cell?.answers?.inspector?.answer || null);
    }
  }, [cell]); // eslint-disable-line

  // useEffect(() => {
  //   let prevValue: string | null = null;
  //   if (cell) {
  //     prevValue = isQC
  //       ? cell?.answers?.qc?.answer
  //       : cell?.answers?.inspector?.answer;
  //   }
  //   if (value != null && value !== prevValue) {
  //     const delayInputTimeoutId = setTimeout(() => {
  //       updatedValue(value, cell?.id);
  //     }, 800);
  //     return () => clearTimeout(delayInputTimeoutId);
  //   }
  // }, [value, cell]); // eslint-disable-line

  const onTextFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (
      header?.tableElementSettings?.headerSettings?.inputFormat === "TextOnly"
    ) {
      const filtered = event.target.value.replace(/[^a-zA-Z\s]/g, "");
      setValue(filtered);
    } else {
      setValue(value);
    }
  };

  const onTextFieldBlur = () => {
    let prevValue: string | null = null;
    if (cell) {
      prevValue = isQC
        ? cell?.answers?.qc?.answer
        : cell?.answers?.inspector?.answer;
    }
    if (value != null && value !== prevValue) {
      updatedValue(value, cell?.id);
    }
  };

  return (
    <>
      {header?.tableElementSettings?.headerSettings?.inputType === "OpenEnd" &&
        header?.tableElementSettings?.headerSettings?.inputFormat ===
          "OpenText" && (
          <TextField
            sx={{
              width: "100%",
              my: 0.75,
              "& .MuiOutlinedInput-input": { padding: 1 },
              "& .MuiOutlinedInput-root": { padding: 0 },
            }}
            id="outlined-basic"
            multiline
            variant="outlined"
            value={value}
            onChange={onTextFieldChange}
            onBlur={onTextFieldBlur}
            onKeyDown={(e) => {
              if (e.key === " ") {
                e.stopPropagation();
              }
            }}
            disabled={disabled}
            slotProps={{
              htmlInput: { maxLength: MAX_CHAR_LIMIT },
            }}
          />
        )}
      {header?.tableElementSettings?.headerSettings?.inputType === "OpenEnd" &&
        header?.tableElementSettings?.headerSettings?.inputFormat ===
          "TextOnly" && (
          <TextField
            sx={{
              width: "100%",
              my: 0.75,
              "& .MuiOutlinedInput-input": { padding: 1 },
              "& .MuiOutlinedInput-root": { padding: 0 },
            }}
            id="text-only"
            multiline
            variant="outlined"
            value={value}
            onChange={onTextFieldChange}
            onBlur={onTextFieldBlur}
            onKeyDown={(e) => {
              if (e.key === " ") {
                e.stopPropagation();
              }
            }}
            disabled={disabled}
            slotProps={{
              htmlInput: { maxLength: MAX_CHAR_LIMIT },
            }}
          />
        )}
      {header?.tableElementSettings?.headerSettings?.inputType === "OpenEnd" &&
        header?.tableElementSettings?.headerSettings?.inputFormat ===
          "NumbersOnly" && (
          <TextField
            sx={{
              width: "100%",
              height: 40,
              padding: 0,
              my: 0.75,
              "& .MuiOutlinedInput-input": { padding: 1 },
              "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                {
                  display: "none",
                  margin: 0,
                },
              "& input[type=number]": {
                MozAppearance: "textfield",
              },
            }}
            id="outlined-basic"
            variant="outlined"
            type="number"
            value={value}
            onChange={onTextFieldChange}
            onBlur={onTextFieldBlur}
            disabled={disabled}
            onKeyDown={(e) => {
              if (
                e.key === "-" ||
                e.key === "e" ||
                e.key === "E" ||
                e.key === "+"
              ) {
                e.preventDefault();
              }
            }}
            slotProps={{
              htmlInput: { maxLength: MAX_CHAR_LIMIT },
            }}
          />
        )}
      {header?.tableElementSettings?.headerSettings?.inputType === "OpenEnd" &&
        header?.tableElementSettings?.headerSettings?.inputFormat ===
          "Currency" && (
          <TextField
            sx={{
              width: "100%",
              height: 40,
              padding: 0,
              my: 0.75,
              "& .MuiOutlinedInput-input": { padding: 1 },
              "& .MuiOutlinedInput-root": { pl: 0 },
              "& .MuiInputAdornment-root": { mr: -1 },
              "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                {
                  display: "none",
                  margin: 0,
                },
              "& input[type=number]": {
                MozAppearance: "textfield",
              },
            }}
            id="outlined-basic"
            variant="outlined"
            type="number"
            value={value}
            onChange={onTextFieldChange}
            onBlur={onTextFieldBlur}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoneyOutlinedIcon />
                  </InputAdornment>
                ),
              },
              htmlInput: { maxLength: MAX_CHAR_LIMIT },
            }}
            disabled={disabled}
          />
        )}
      {header?.tableElementSettings?.headerSettings?.inputType === "OpenEnd" &&
        header?.tableElementSettings?.headerSettings?.inputFormat ===
          "Percentage" && (
          <TextField
            sx={{
              width: "100%",
              height: 40,
              padding: 0,
              my: 0.75,
              "& .MuiOutlinedInput-input": { padding: 1 },
              "& .MuiOutlinedInput-root": { pr: 1 },
              "& .MuiInputAdornment-root": { ml: 0 },
              "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                {
                  display: "none",
                  margin: 0,
                },
              "& input[type=number]": {
                MozAppearance: "textfield",
              },
            }}
            id="outlined-basic"
            variant="outlined"
            type="number"
            value={value}
            onChange={onTextFieldChange}
            onBlur={onTextFieldBlur}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <PercentOutlinedIcon />
                  </InputAdornment>
                ),
              },
              htmlInput: { maxLength: MAX_CHAR_LIMIT },
            }}
            disabled={disabled}
          />
        )}
    </>
  );
}
